export function getGoogleOAuthRedirectUri(): string {
  return new URL("/login", window.location.origin).href;
}

export function getMicrosoftOAuthRedirectUri(): string {
  return new URL("/microsoft_oauth_redirect", window.location.origin).href;
}
